import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'currencySymbol',
  standalone: true,
})
export class CurrencySymbolPipe implements PipeTransform {
  private _translate = inject(TranslateService);

  transform(value: string): string {
    const lang = this._translate.currentLang || 'en';

    switch (value) {
      case 'EGP':
        return lang === 'ar' ? 'ج.م' : 'EGP';
      case 'USD':
        return '$';
      case 'EUR':
        return '€';
      default:
        return value;
    }
  }
}
